import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [authed, setAuthed] = useState(null);
  const [hasWedding, setHasWedding] = useState(false);
  const [hasAccess, setHasAccess] = useState(false);

  const loadMe = useCallback(async () => {
    const token = localStorage.getItem("pmw_token");
    if (!token) {
      setAuthed(false);
      setUser(null);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setHasWedding(data.has_wedding);
      setHasAccess(!!data.user?.has_access);
      setAuthed(true);
    } catch {
      localStorage.removeItem("pmw_token");
      setAuthed(false);
      setUser(null);
    }
  }, []);

  useEffect(() => {
    loadMe();
  }, [loadMe]);

  const login = (token, u, has) => {
    localStorage.setItem("pmw_token", token);
    setUser(u);
    setHasWedding(has);
    setHasAccess(!!u?.has_access);
    setAuthed(true);
  };

  // Apply an auth response ({token, user, has_wedding}) and return where to send the user next.
  const authenticate = (data) => {
    login(data.token, data.user, data.has_wedding);
    if (data.has_wedding) return "/app";
    if (data.user?.has_access) return "/onboarding";
    if (data.user?.products?.bachelorette_planner) return data.has_bachelorette ? "/bach" : "/bach/onboarding";
    return "/planners";
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { console.error("logout request failed", e); }
    localStorage.removeItem("pmw_token");
    setUser(null);
    setAuthed(false);
    setHasWedding(false);
    setHasAccess(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, authed, hasWedding, setHasWedding, hasAccess, setHasAccess, login, authenticate, logout, loadMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
